module.exports = __webpack_public_path__ + "media/application/images/2018/icon-worth-considering-dfbc33ff44fe016f81c2c931fbe8141c.svg";